"use client";

import React from "react";
import { FaCube } from "react-icons/fa";
import getBlockTotalReward from "lib/block/getBlockTotalReward";
import styles from "./CardList.module.css";
import { BlockItem } from "./types";
import { formatTimeAgo } from "./utils";

interface BlockCardProps {
  block: BlockItem;
  isNew: boolean;
}

const BlockCard: React.FC<BlockCardProps> = ({ block, isNew }) => {
  const totalReward = getBlockTotalReward(block as any);

  return (
    <div
      className={styles.card}
      style={{
        opacity: isNew ? 0 : 1,
        animation: isNew ? "fadeIn 0.5s ease-in-out forwards" : undefined,
        transition: "all 0.3s ease-in-out",
      }}
    >
      <div className={styles.cardHeader}>
        <a
          href={`/block/${block.height}`}
          className={styles.cardTitle}
          style={{ display: "flex", alignItems: "center", gap: "0.375rem" }}
        >
          <FaCube size={14} color="#3b82f6" />
          {block.height.toLocaleString()}
        </a>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Txn</span>
          <span className={styles.cardValue}>{block.transaction_count}</span>
        </div>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>Reward</span>
          <span className={styles.cardValue}>
            {totalReward.dp(10).toFixed()}
          </span>
        </div>
        <div className={styles.cardRow} style={{ justifyContent: "flex-end" }}>
          <span className={styles.cardTime} style={{ fontSize: "0.875rem" }}>
            {formatTimeAgo(block.timestamp)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BlockCard;
